/**
 * Browser tab titles.
 *
 * Set from the app rather than the document, so the client tab carries the real
 * stored client name once the project has loaded from Supabase.
 */

export const STAFF_TITLE = 'Portal Productions — Staff'
export const CLIENT_ACCESS_TITLE = 'Portal Productions — Client'

/** "[client_name] — Portal", falling back until the project has loaded. */
export function projectTitle(clientName: string): string {
  const name = clientName.trim()
  return name ? `${name} — Portal` : CLIENT_ACCESS_TITLE
}

export function setPageTitle(title: string): void {
  if (typeof document !== 'undefined' && document.title !== title) document.title = title
}
